<template>
  <b-input-group size="sm" class="w-100 mx-2" style="max-width: 300px">
    <b-input-group-prepend>
      <b-input-group-text class="py-0">
        <b-spinner v-if="searching" small style="width: 0.85rem; height: 0.85rem"></b-spinner>
        <b-icon-search v-else></b-icon-search>
      </b-input-group-text>
    </b-input-group-prepend>

    <!-- Busca mientras se escribe (300 ms después de la última tecla); Enter busca de inmediato. -->
    <input
      v-model="query"
      placeholder="Buscar por nombre, apellido, email o rol"
      type="search"
      class="form-control"
      @input="scheduleSearch"
      @keyup.enter="search"
    />
  </b-input-group>
</template>

<script>
import { mapGetters } from 'vuex'

const DEBOUNCE_MS = 300

export default {
  name: 'UserSearch',

  data () {
    return {
      query: this.$store.state.userModule.query || null,
      timer: null,
      lastSearched: this.$store.state.userModule.query || null,
      searching: false
    }
  },

  computed: {
    ...mapGetters('userModule', ['isSearchingMode'])
  },

  beforeDestroy () {
    clearTimeout(this.timer)
  },

  methods: {
    scheduleSearch () {
      clearTimeout(this.timer)
      this.timer = setTimeout(this.search, DEBOUNCE_MS)
    },

    async search () {
      clearTimeout(this.timer)

      const text = (this.query || '').trim()
      if (text === (this.lastSearched || '')) return
      this.lastSearched = text

      if (!text) return this.clear()

      this.$store.commit('userModule/setQuery', text)

      this.searching = true
      const { error, message } = await this.$store.dispatch('userModule/search', { search: text, page: 1 })
      this.searching = false

      if (error) this.$notify({ error, message }, 'Busqueda usuarios')
    },

    async clear () {
      this.$store.commit('userModule/setQuery', null)

      this.searching = true
      await this.$store.dispatch('userModule/getUsers', 1)
      this.searching = false
    }
  }
}
</script>
